/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bidbattle__Open_SeatsInputs */

const en_bidbattle__open_seats = /** @type {(inputs: Bidbattle__Open_SeatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open seats`)
};

/**
* | output |
* | --- |
* | "Open seats" |
*
* @param {Bidbattle__Open_SeatsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const bidbattle__open_seats = /** @type {((inputs?: Bidbattle__Open_SeatsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bidbattle__Open_SeatsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_bidbattle__open_seats(inputs)
});